// Pull a human-readable message out of whatever the network layer / a backend
// hands us — a plain string, a JSON string, or an object using any of the common
// message keys ({message}, {error}, axios-style {response:{data}}, …). Falls back
// to `defaultMsg` only when nothing usable is found.
export const errorMessageHandler = (
  err,
  defaultMsg = "Something went wrong."
) => {
  // Scan an object for the first string value under a known message key.
  const pick = (obj) => {
    if (!obj || typeof obj !== "object") return "";
    const keys = [
      "message",
      "error",
      "errorMessage",
      "msg",
      "detail",
      "description",
    ];
    for (let i = 0; i < keys.length; i += 1) {
      const v = obj[keys[i]];
      if (typeof v === "string" && v.trim()) return v.trim();
    }
    return "";
  };

  if (err === null || err === undefined) return defaultMsg;

  // A bare string may be plain text or a JSON blob.
  if (typeof err === "string") {
    const s = err.trim();
    if (!s) return defaultMsg;
    try {
      const parsed = JSON.parse(s);
      if (typeof parsed === "string" && parsed.trim()) return parsed.trim();
      return pick(parsed) || defaultMsg;
    } catch (e) {
      return s;
    }
  }

  if (typeof err === "object") {
    const msg = pick(err);
    if (msg) {
      // The value itself might be a JSON string wrapping a message.
      try {
        const inner = pick(JSON.parse(msg));
        if (inner) return inner;
      } catch (e) {
        // not JSON — fall through to the plain string
      }
      return msg;
    }
    // Axios-style nested response body.
    if (err.response && typeof err.response === "object") {
      const nested = pick(err.response.data) || pick(err.response);
      if (nested) return nested;
    }
  }

  return defaultMsg;
};
